var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UpgradeDialog',{attrs:{"detail":_vm.state.detail},model:{value:(_vm.state.open),callback:function ($$v) {_vm.$set(_vm.state, "open", $$v)},expression:"state.open"}})}
var staticRenderFns = []

export { render, staticRenderFns }